// extracted by mini-css-extract-plugin
module.exports = {"bannerCtaFocus":"TabFocus_bannerCtaFocus__HrbpJ","imageFocus":"TabFocus_imageFocus__44h_k"};